<!-- begin:: Root -->
<div class="sp-grid sp-grid--hor sp-grid--root">
    <!-- begin:: Page -->
    <div class="sp-grid__item sp-grid__item--fluid sp-grid sp-grid--ver sp-page">

        <!-- begin:: Aside -->
        <app-sidebar></app-sidebar>
        <!-- end:: Aside -->

        <!-- begin:: Wrapper -->
        <div class="sp-grid__item sp-grid__item--fluid sp-grid sp-grid--hor sp-wrapper" id="sp_wrapper">

            <!-- begin:: Header -->
            <app-header></app-header>
            <!-- end:: Header -->

            <div class="sp-content  sp-grid__item sp-grid__item--fluid sp-grid sp-grid--hor" id="sp_content">

                <!-- begin:: Subheader -->
                <div style="display: none;" class="sp-subheader sp-grid__item sp-subheader--top-fixed"
                    id="sp_subheader">
                    <div style="padding-top: 20px; padding-bottom: 20px;" class="sp-container  sp-container--fluid ">
                        <!-- begin:: Toolbar -->
                        <div class="sp-subheader__toolbar">
                            <div class="sp-subheader__wrapper">

                            </div>
                        </div>
                        <!-- end:: Toolbar -->

                        <!-- begin:: Breadcrumbs -->
                        <app-breadcrumbs></app-breadcrumbs>
                        <!-- end:: Breadcrumbs -->
                    </div>
                </div>
                <!-- end:: Subheader -->

                <!-- begin:: Content -->
                <div class="sp-container  sp-container--fluid sp-grid__item sp-grid__item--fluid p-0 m-t-15 sp-content-dash">
 
              
                    <router-outlet ></router-outlet>

                </div>
                <!-- end:: Content -->

            </div>
        </div>
        <!-- end:: Wrapper -->
    </div>
    <!-- end:: Page -->
</div>

<app-scrolltop></app-scrolltop>
<!-- end::Scrolltop -->

<!-- start:: indicador de procesos -->
<div *ngIf="listProcess" [ngClass]="{'d-none': !showProcess}" class="process-container">    
    <div *ngIf="listProcess.length == 1" class="one-process">
        <div class="close-process">
            <i class="fa-solid fa-xmark" (click)="hiddenProcess(listProcess[0].codForm)"></i>
        </div>
        <div class="content-process" #oneProcess>
            <p class="process-text label">{{listProcess[0].nomProg}}</p>
            <div class="d-flex align-items-center">
                <div class="container">
                    <div class="circular-progress">
                    </div>
                </div>    
                <span class="process-status label">
                    {{parseInt(listProcess[0].porProc)}}%
                </span>
                <a class="process-link" (click)="generarPage(admin, true)">
                    <i class="fa-solid fa-angle-right"></i>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="listProcess.length > 1">
        <div class="accordion accordion-outline" id="accordionExample3">
            <div>
                <div id="headingOne3">
                    <div #acordionHeader class="header-collapsed collapsed title header-container"
                        data-toggle="collapse" data-target="#acordeon" aria-expanded="false" aria-controls="acordeon">
                        <div class="d-flex align-items-center">
                            Ejecutando {{listProcess.length}} procesos
                        </div>
                        <div class="">
                            <i class="fa-solid fa-angle-up mr-2"></i>
                            <i class="fa-solid fa-xmark" (click)="hiddenProcess()"></i>
                        </div>
                    </div>
                </div>
                <div id="acordeon" class="card-body-wrapper pt-2 collapse content-container"
                    aria-labelledby="headingOne3" data-parent="#accordionExample3">
                    <div *ngFor="let process of listProcess;" class="list-process">
                        <div class="close-process">
                            <i class="fa-solid fa-xmark" (click)="hiddenProcess(process.codForm)"></i>
                        </div>
                        <div class="content-process" #listProcessDom>
                            <p class="process-text label">{{process.nomProg}}</p>
                            <div class="d-flex align-items-center">
                                <div class="container">
                                    <div class="circular-progress">
                                    </div>
                                </div>    
                                <span class="process-status label">
                                    {{parseInt(process.porProc)}}%
                                </span>
                                <a class="process-link" (click)="generarPage(admin, true)">
                                    <i class="fa-solid fa-angle-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end:: indicador de procesos -->

<!-- start::backgrund modales personalizado -->
<div id="background" class="background-modal"></div>
<!-- end::backgrund modales personalizado -->




<app-chatia></app-chatia>


